export default {
  nhap_tu_khoa: "Nhập từ khóa.",
  start: "Nơi xuất phát",
  end: "Nơi đến",
  chon_ngay_di: 'Ngày đi',
  tim_ve: 'Tìm vé',
  cam_ket: 'Cam kết hoàn 150% nếu nhà xe không giữ vé',
  loc: 'Lọc',
  xoa_loc: 'Xóa lọc',
  gio_di: 'Giờ đi',
  nha_xe: 'Nhà xe',
  gia_ve: 'Giá vé',
  danh_gia: 'Đánh giá',
  tro_len: 'Trở lên',
  sang_som: 'Sáng sớm',
  buoi_sang: 'Buổi sáng',
  buoi_chieu: 'Buổi chiều',
  buoi_toi: 'Buổi tối',
  bo_loc: 'Bộ lọc',
  list_empty: 'Danh sách rổng',
  no_result: 'Không tìm thấy',
  states_cities: 'Tỉnh - Thành Phố',
  districts: 'Quận - Huyện',
  close: 'Close',
  tickets_booking: 'Đặt vé xe online',
};
